import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("rivot_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default client;

export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_2fd27874-825a-423c-a47f-8d96b8658c0f/artifacts/ylpiuj42_RIVOT%20New%20Logo%20White.webp";

export const BG_WELCOME =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_2fd27874-825a-423c-a47f-8d96b8658c0f/artifacts/ytt59izm_SERVICE%20BOOK.jpg";

export const BG_FORM =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_2fd27874-825a-423c-a47f-8d96b8658c0f/artifacts/z32d8soc_STARTUP%20KIT%20%282%29.jpg";

export const BG_THANKS =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_2fd27874-825a-423c-a47f-8d96b8658c0f/artifacts/tiu1m2ol_STARTUP%20KIT%20%284%29.jpg";
